import React, { useState, useEffect } from 'react';
import {NavLink} from 'react-router-dom'
import {Accordion,AccordionSummary,AccordionDetails,Grid,Container} from '@material-ui/core';
import {FaChevronDown, FaCaretRight} from 'react-icons/fa';
import { useDispatch, useSelector } from 'react-redux';
import QNA from '../../models/qna.model';
import pageMeta from '../../models/pagemeta.model';
import { fetchFaq } from '../../services/faq.service';
import Preloader from '../../components/PreLoader';
import Paginate from '../../components/pagination';
import Breadcrumb from '../../components/Breadcrumb';
// import translate from '../../translation.json';
import { lang } from '../../config/app.config';
import {TranslationState} from '../../store/ActionReducers/translation.actionreducer';
import HomeGallery from './../Home/Gallery/index';
import { httpbase } from '../../utils/axios.utils';

interface state{
  faq:{
    loading:boolean,
    faqs:Array<QNA>,
    meta:pageMeta
  }
}


const FAQ:React.FC =  () =>{  

  const dispatch = useDispatch();
  const state = useSelector((state:state)=>{
    const {faq} = state;
    return faq;
  })
  const {faqs,loading,meta} =  state;
  
  const [faqCategory,setFaqCategory] = useState<any[]>([])

  useEffect(()=>{
    setFaqCategory(faqs)
  },[faqs]) 

  const [activeCategory,setCategory] = useState(0)

  const LoadFaq = (page:number=1) =>{
    dispatch(fetchFaq());
  }

  useEffect(()=>{
    LoadFaq();
  },[]); //eslint-disable-line


 const stateTr = useSelector((state:{translation:TranslationState})=>state.translation);

  return(
    <>
    <Breadcrumb routes={[{title:stateTr.translation?stateTr.translation.faq[lang==='np'?"value_np":"value_en"]:""}]}/>

    <div className="section-padding-2">
    {loading?<Preloader/>:
      <Container maxWidth="lg">
        <Grid container className="justify-content-center">
          <Grid item xs={12} md={3}>
          <ul className="ecn-sidebar faq-sidebar">
            {
              faqCategory && faqCategory.length?
              faqCategory.map((faq,i)=>{
                return(
                <li 
                key={faq.id}
                onClick={()=>setCategory(i)} 
                >
                      <p className={ (i === activeCategory) ? 'active' : ''}>
                        <span><FaCaretRight/></span>
                      {faq.name}</p>
               </li>
              )})
              : 'Currently No Categories Available'
            }
            </ul>
            </Grid>
            <Grid item xs={12} md={9} className="faq-detail">
            { faqCategory?.length>0 && faqCategory[activeCategory]?.value?.map((item:any)=> {
            return (
              <div className="cat-faq-wrapper">
                  <div className="cat-faq-list">
                  <h3>
                  {item?.title}
                </h3>
              <p>
                {item?.value }
              </p>
                  </div>
              </div>
              )
            }) 
           }
              
              </Grid>
           
         
        </Grid>
        
      </Container>
    }
    </div>
    </>
  )
}

export default FAQ;